/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AutoCompleteResult} from "../model/auto-complete-result";
import {FetchDataType} from "../model/fetch-data-type";
import {SearchParamRequest} from "../model/search-param-request";

@Injectable({
    providedIn: "root",
})
export class SimAutoCompleteService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public fetchData(dataType: FetchDataType, searchParams: SearchParamRequest) {
        return super.get<AutoCompleteResult[]>(`/api/AutoComplete/FetchData`, {dataType: dataType, searchParams: searchParams}, ["searchParams"]);
    }

    public fetchSingle(dataType: FetchDataType, id: string) {
        return super.get<any>(`/api/AutoComplete/FetchSingle`, {dataType: dataType, id: id});
    }
}